module.exports = __webpack_public_path__ + "img/404-brain.b8a3ca64.png";